import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoThumbsMiddle = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ThumbsMiddle</title>
    <path
      d="M20.665 18.574c7.836 1.121 10.022-1.026 9.135-2.825-.636-1.29-3.832-1.44-5.76-1.846-1.248-.264-2.575-1.788-4.8-2.877-2.226-1.089-11.212-.774-12.47 0-1.257.775-2.355 1.759-2.355 6.056l.18 3.75c.148 1.983 1.784 3.447 3.294 2.507m12.776-4.765-.054 3.806c0 1.39-.664 2.57-2.085 2.78-1.42.21-2.05-.091-2.347-.454m4.486-6.132v-1.492m-4.486 7.624c-.974.862-2.91 1.105-4.198-.212m4.198.212V19.41m-4.198 5.084c-1.685.796-3.287.353-4.092-1.155m4.092 1.155v-5.37M7.889 23.34v-4.765"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoThumbsMiddle;
